<template>
	<div v-if="show" class="mainlandingbartop d-flex d-justify-content-center align-items-center text-center w-100" ref="mainlandingbartopf">
		<router-link v-if="promobar.cta == 3 || !promobar.cta" @click="$scrollToTop" to="/t/scontact" class="tt-dropdown-item">
			<svg role="button" class="ctapdb1 mp img-fluid" width="199" height="40" viewBox="0 0 199 40" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect width="199" height="40" rx="20" fill="#75AE3D" />
				<text class="ctapdb" x="98.5" y="21.5" :font-size="$t('landinglearning.cta1fontsize', '16')" dominant-baseline="middle" text-anchor="middle">{{ $t('promolandingbar.text1', 'Book Executive Call') }}</text>
			</svg>
		</router-link>

		<router-link v-if="promobar.cta == 2 || !promobar.cta" @click="$scrollToTop" to="/members/subscriptions" class="tt-dropdown-item">
			<svg role="button" class="ctapdb1 mp img-fluid" width="199" height="40" viewBox="0 0 199 40" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect width="199" height="40" rx="20" fill="#75AE3D" />
				<text class="ctapdb" x="98.5" y="21.5" :font-size="$t('landinglearning.cta1fontsize', '16')" dominant-baseline="middle" text-anchor="middle">{{ $t('promolandingbar.text2', 'Start Trial') }}</text>
			</svg>
		</router-link>

		<router-link v-if="promobar.cta == 1" @click="$scrollToTop" to="/g/1" id="game-btn" aria-current="page" class="d-none d-lg-block text-nowrap" data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-custom-class="custom-tooltip" :data-bs-title="`<div class='tooltip-body'>${ $t('games.topmenutooltip', 'Play our game Land of Titans and learn by doing, not just watching') }</div>`">
			<svg role="button" class="ctapdb1" width="199" height="40" viewBox="0 0 199 40" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect width="199" height="40" rx="20" fill="#75AE3D" />
				<text class="ctapdb" x="98.5" y="21.5" :font-size="$t('landinglearning.cta1fontsize', '16')" dominant-baseline="middle" text-anchor="middle">{{ $t('promolandingbar.text3', 'Play Now') }}</text>
			</svg>
		</router-link>
		<div v-if="promobar.cta == 1" id="game-btn" role="button" aria-current="page" class="d-lg-none text-nowrap" data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-custom-class="custom-tooltip" :data-bs-title="`<div class='tooltip-body'>${ $t('games.topmenutooltipm', 'Desktop version is availabe. Please, use your desktop computer') }</div>`">
			<svg role="button" class="ctapdb1" width="199" height="40" viewBox="0 0 199 40" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect width="199" height="40" rx="20" fill="#75AE3D" />
				<text class="ctapdb" x="98.5" y="21.5" :font-size="$t('landinglearning.cta1fontsize', '16')" dominant-baseline="middle" text-anchor="middle">{{ $t('promolandingbar.text3', 'Play Now') }}</text>
			</svg>
		</div>
	</div>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { promoBarStore } from '@/store/userPromoBarStore';

const promobar = promoBarStore();
const show = ref(true);
const mainlandingbartopf = ref();
let vh = ref(0);

onMounted(
	async () => {
		fixedMenu();
	});

const fixedMenu = async () => {
	vh.value = window.innerHeight / 2;
	let offset = 66;
	document.addEventListener('scroll', function() {
		setTimeout(function() {
			var timeoutId = null;
			if (timeoutId) clearTimeout(timeoutId);
			timeoutId = setTimeout(fixedBar, 30);
		});
	});

	async function fixedBar() {
		// await nextTick();
		setTimeout(() => {
			if (window.scrollY > vh.value + offset) {
				if (mainlandingbartopf.value) mainlandingbartopf.value.style.top = offset + "px";
			} else if (window.scrollY < 10 /*offset + vh.value*/ ) {
				if (mainlandingbartopf.value) mainlandingbartopf.value.style.top = "0px";
			}
		}, 30);
	}
}
</script>
<style scoped lang="scss">
.mainlandingbartop {
	position: sticky;
	top: 0;
	overflow: hidden;
	background: var(--Off-black-100, #161616);
	display: flex;
	padding: 14px 0px;
	/*padding: 24px 0px;*/
	justify-content: center;
	align-items: center;
	gap: 10px;
	align-self: stretch;
	transition: all 0.3s linear;
	z-index: 99;
}

.mainbartoptext1 {
	color: var(--Off-white, #F5F5F5);
	font-family: Roboto;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	letter-spacing: 0.1px;
}

.mainbartoptext2 {
	color: var(--Green-100, #75AE3D);
	font-family: Roboto;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: 0.1px;
}

@media (max-width: 768px) {
	.mainbar {
		font-size: 12px;
	}
}

.ctapdb {
	fill: var(--Off-black-100, #161616);
	text-align: center;
	font-family: Play;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: 0.1px;
}

.ctapdb1 {
	padding: 0;
	margin: 0;
}

.ctapdb1:hover rect {
	fill: #fff;
}

.ctapdb1.mp {
	@media (max-width: 576px) {
		scale: .8;
	}
}
</style>